export const API_URLS = {
  funimationNow: {
    headerModules: '/api/fun/modules/?clear=1&placement=headerv2&territory=',
    footerModules: '/api/fun/modules/?clear=1&placement=headerv2&territory=',
    placementModules: '/api/fun/modules/?clear=1&territory=US',
    show: '/api/source/catalog/title/',
    showEpisodes: '/api/source/catalog/season/',
  },
};
